/**
 * Resolves a route path to a full href that works in both normal and hash mode.
 * Use this instead of NuxtLink when opening links in a new tab (target="_blank"),
 * since NuxtLink doesn't account for hash mode in that case.
 */
export function useResolvedHref(path: Ref<string> | ComputedRef<string>) {
  const router = useRouter();

  return computed(() => {
    const value = path.value;
    if (!value) return "";
    return router.resolve(value).href;
  });
}
